// @flow
import Root from './Root';
import render from './render';

export default (props: Object) => {
  setTimeout(() => {
    render(Root)(props);
  }, 0);
  return null;
};
